import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <a href="https://phishspot.ai/">
              <img
                src="https://phishspot.ai/_next/static/media/logo-light.24e7e499.svg"
                alt="PhishSpot"
              />
            </a>
          </div>

          <nav className="nav">
            <a href="https://phishspot.ai/#features" className="nav-link">
              Features
            </a>
            <a href="https://phishspot.ai/contact-us/" className="nav-link">
              Contact Us
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
